import React, { useState } from "react";
import EditorDescLungaTINYMCE from "../moduliArticolo/EditorDescLungaTINYMCE";
import EditorDescLungaQUILL from "../moduliArticolo/EditorDescLungaQUILL";
import EditorDescLungaSUNEDITOR from "../moduliArticolo/EditorDescLungaSUNEDITOR";
import ImportaTestoOnlineModal, {
  getOnlineTextForLanguage,
  hasTextValue,
} from "./ImportaTestoOnlineModal";

const IntroEditor = ({
  editorType,
  value,
  active,
  onChange,
  onActivate,
  onPasteHtml,
  copyDisabledReason,
  onOpenCopy,
  buttonClassesWhite,
}) => (
  <div className="modificaProdottiTestoIntroColumn modificaProdottiTestoIntroEditor">
    <div className="modificaProdottiTestoIntroHeading">
      <div>
        <h3 className="ma0">Testo intro</h3>
        <p className="mt1 mb0 f6">descrizioniSuPS.descIntro</p>
      </div>
      {!active && (
        <div className="flex items-center">
          <button
            type="button"
            className={`${buttonClassesWhite} modificaProdottiTestoIntroAction mr2`}
            onClick={onActivate}
            title="Modifica testo intro"
            aria-label="Modifica testo intro"
          >
            <span className="material-symbols-outlined" aria-hidden="true">
              edit
            </span>
          </button>
          <button
            type="button"
            className={`${buttonClassesWhite} modificaProdottiTestoIntroPaste`}
            onClick={onPasteHtml}
          >
            Incolla HTML
          </button>
        </div>
      )}
      <button
        type="button"
        className={`${buttonClassesWhite} modificaProdottiImportaTestoButton ml2`}
        disabled={Boolean(copyDisabledReason)}
        title={copyDisabledReason}
        aria-label="Copia da BOT"
        onClick={onOpenCopy}
      >
        Copia da BOT
      </button>
    </div>

    <div className="modificaProdottiTestoIntroContent">
      {editorType === "tinyMCE" && active && (
        <EditorDescLungaTINYMCE
          nuovaDesc={!value}
          initialValue={value ? undefined : ""}
          value={value}
          handleChangeEditor={onChange}
        />
      )}
      {editorType === "quill" && active && (
        <EditorDescLungaQUILL
          nuovaDesc={!value}
          initialValue={value ? undefined : ""}
          value={value}
          handleChangeEditor={onChange}
        />
      )}
      {editorType === "sun" && active && (
        <EditorDescLungaSUNEDITOR
          nuovaDesc={!value}
          initialValue={value ? undefined : ""}
          value={value}
          handleChangeEditor={onChange}
        />
      )}
      {!active &&
        (value ? (
          <div dangerouslySetInnerHTML={{ __html: value }} />
        ) : (
          <p className="ma0 f6">Nessun testo intro per questa lingua.</p>
        ))}
    </div>
  </div>
);

function TestoIntro({
  prodottoTemp,
  lang,
  editorType,
  active,
  onChange,
  onActivate,
  onPasteHtml,
  onImportIntro,
  prestashopOnline,
  prestashopOnlineLoading,
  prestashopOnlineError,
  buttonClassesWhite,
}) {
  const [copyModalOpen, setCopyModalOpen] = useState(false);
  const introValue =
    prodottoTemp?.descrizioniSuPS?.descIntro?.[lang] ?? "";
  const longDescriptionValue =
    prodottoTemp?.descrizioniSuPS?.descLunga?.[lang] ?? "";
  const dominoShortHtml =
    prodottoTemp?.descrizioniSuPS?.descBreve?.[lang] ?? "";
  const botShortHtml = getOnlineTextForLanguage(
    prestashopOnline,
    "BOT",
    "descriptionShort",
    lang,
  );
  let copyDisabledReason = "";
  if (hasTextValue(introValue)) {
    copyDisabledReason =
      "Il testo intro Domino è già presente nella lingua corrente.";
  } else if (prestashopOnlineLoading) {
    copyDisabledReason = "Lettura dei dati online in corso.";
  } else if (prestashopOnlineError) {
    copyDisabledReason = prestashopOnlineError;
  } else if (!prestashopOnline?.sites?.BOT?.available) {
    copyDisabledReason =
      prestashopOnline?.sites?.BOT?.unavailableMessage ||
      "BOT non è interrogabile per questo articolo.";
  } else if (!hasTextValue(botShortHtml)) {
    copyDisabledReason =
      "Su BOT non c’è una descrizione breve nella lingua corrente.";
  }

  return (
    <section className="modificaProdottiPagina modificaProdottiTestoIntroPagina pa2">
      <div className="modificaProdottiTestoIntroLayout">
        <IntroEditor
          editorType={editorType}
          value={introValue}
          active={active}
          onChange={onChange}
          onActivate={onActivate}
          onPasteHtml={onPasteHtml}
          copyDisabledReason={copyDisabledReason}
          onOpenCopy={() => setCopyModalOpen(true)}
          buttonClassesWhite={buttonClassesWhite}
        />

        <div className="modificaProdottiTestoIntroColumn modificaProdottiTestoIntroReference">
          <div className="modificaProdottiTestoIntroHeading">
            <div>
              <h3 className="ma0">Descrizione lunga</h3>
              <p className="mt1 mb0 f6">
                Riferimento in sola lettura · seleziona e copia le parti utili
              </p>
            </div>
          </div>
          <div className="modificaProdottiTestoIntroContent">
            {longDescriptionValue ? (
              <div
                dangerouslySetInnerHTML={{ __html: longDescriptionValue }}
              />
            ) : (
              <p className="ma0 f6">
                Nessuna descrizione lunga per questa lingua.
              </p>
            )}
          </div>
        </div>
      </div>
      <ImportaTestoOnlineModal
        open={copyModalOpen}
        sourceTitle="Descrizione breve online BOT"
        sourceHtml={botShortHtml}
        dominoShortHtml={dominoShortHtml}
        targetLabel="Testo intro"
        onUse={(html) => {
          onImportIntro(html);
          setCopyModalOpen(false);
        }}
        onClose={() => setCopyModalOpen(false)}
        buttonClassesWhite={buttonClassesWhite}
      />
    </section>
  );
}

export default TestoIntro;
